export default __webpack_public_path__ + "4d6d6ff533211672818db767746ad238.jpg";